import React from "react";
import "./../assets/css/Scope.css";
import { Box } from "@mui/material";
import ImageCarousel from "../components/ImageCarousel";
import ScopeImageStack from "../components/ScopeImageStack";
import { useDocumentMetaData } from "../components/useDocumentMetaData";

const Scope = () => {
  useDocumentMetaData({
    title: "Our Scope - MidWest Group Construction Services",
    description:
      "Explore the full scope of MidWest Group’s construction services including steel stud framing, drywall, insulation, taping, suspended ceilings, custom walls, and architectural features.",
    keywords:
      "MidWest construction scope, steel stud framing, drywall services, insulation contractors, taping, acoustic ceilings, specialty ceilings, curved walls, architectural features, subcontractor services",
    canonical: "https://www.midwest-group.com/scope",
    author: "MidWest Group",
    ogTitle: "MidWest Group - Our Construction Scope",
    ogDescription:
      "From steel stud framing and drywall to custom ceilings and architectural features, MidWest Group delivers expert construction solutions across North America.",
    ogImage:
      "https://www.midwest-group.com/static/media/midwestlogo.44c18281703536901c7e.png",
    ogUrl: "https://www.midwest-group.com/scope",
    twitterTitle: "Our Scope - MidWest Group Services",
    twitterDescription:
      "Discover MidWest Group’s expertise in steel stud framing, drywall, ceilings, and custom architectural construction features.",
    twitterImage:
      "https://www.midwest-group.com/static/media/midwestlogo.44c18281703536901c7e.png",
  });

  return (
    <Box sx={{ paddingBottom: 5 }}>
      <div className="scope_main_container">
        <div className="scope_title_container">
          <h1 className="scope_title">Our Scope</h1>
        </div>

        <div className="scope_bg_container">
          <div className="scope_bg_title_container">
            <ul className="scope-ul-margin slide-in-text">
              <li className="scope_bg_title">Steel Stud Framing</li>
              <li className="scope_bg_title">Drywall & Insulation </li>
              <li className="scope_bg_title">Taping</li>
              <li className="scope_bg_title">
                Suspended, Acoustic, & Specialty Ceilings
              </li>
              <li className="scope_bg_title">
                Curved, Radius, & Wave Walls and Bulkheads
              </li>
              <li className="scope_bg_title">Custom Architectural Features</li>
            </ul>
          </div>
        </div>

        <div className="scope_image_carousel_container">
          <ImageCarousel />
        </div>

        <div className="scope_image_content_container">
          <ScopeImageStack />
        </div>
      </div>
    </Box>
  );
};

export default Scope;
